import FormFieldErrorMessage from "@JohnLewisPartnership/checkout-forms/dist/components/form-field-error-message/FormFieldErrorMessage";
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { CameraOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CameraOutlined";
import Input from "@JohnLewisPartnership/jl-design-system/dist/elements/input/Input";
import mime from "mime/lite";
import PropTypes from "prop-types";
import React, { useRef } from "react";
import styles from "./image-upload.module.scss";
import UploadPreview from "./upload-preview/upload-preview";
import { isNotSupportedMedia, isValidFileSize, loadFile } from "./utils";

function ImageUpload(props) {
  const {
    onAttachmentAdded,
    maxUploads,
    onAttachmentRemoved,
    attachments,
    id,
    describedById,
    fileMeta,
    supportedMediaTypePrefix,
    setAttachmentError,
  } = props;

  const inputEl = useRef(null);

  const handleUploadImageButtonClick = () => {
    if (inputEl?.current?.input?.click) {
      inputEl.current.input.click();
    }
  };

  const handleImageChange = event => {
    event.preventDefault();

    const file = event.target.files[0];

    if (!file) return;

    const fileType = mime.getType(file.name);

    if (!isValidFileSize(file)) {
      setAttachmentError({
        name: id,
        error: `Sorry, we can't upload images larger than 5MB. Please reduce size and try again.`,
      });
      return;
    }

    if (isNotSupportedMedia(fileType, supportedMediaTypePrefix)) {
      setAttachmentError({
        name: id,
        error: `Sorry, we can't upload this type of image. Please provide images in formats like jpg, jpeg, png, heic or gif.`,
      });
      return;
    }

    loadFile(id, file, onAttachmentAdded).catch(() => {
      setAttachmentError({ name: id, error: `An error occurred while processing the file. Please try again.` });
    });
  };

  const hasError = fileMeta.error && fileMeta.touched;
  return (
    <div className={styles["image-upload"]}>
      <SecondaryButton
        className={styles["image-upload__button"]}
        disabled={attachments.length >= maxUploads}
        onClick={handleUploadImageButtonClick}
      >
        <CameraOutlined iconState={attachments.length >= maxUploads ? "icon-disabled" : "default"} /> &nbsp;Add photos
      </SecondaryButton>
      <Input
        {...props}
        ref={inputEl}
        onChange={handleImageChange}
        disabled={attachments.length >= maxUploads}
        className={styles["image-upload__input"]}
      />
      {hasError && <FormFieldErrorMessage id={id} describedById={`${describedById}-error`} message={fileMeta.error} />}

      {attachments.length ? (
        <UploadPreview attachments={attachments} onImageRemoved={onAttachmentRemoved} id={id} />
      ) : null}
    </div>
  );
}

ImageUpload.propTypes = {
  ...Input.propTypes,
  onAttachmentAdded: PropTypes.func.isRequired,
  onAttachmentRemoved: PropTypes.func.isRequired,
  maxUploads: PropTypes.number.isRequired,
  supportedMediaTypePrefix: PropTypes.string,
};

export default ImageUpload;
